var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g2, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 188,
    viewBox: "0 0 99 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4079_118889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9264 68.0593C26.6121 68.0593 25.5792 67.5882 24.8593 66.6645C23.8555 65.3806 24.2207 63.8749 24.5382 62.5464L24.6045 62.2732C24.9023 61.0156 25.2408 59.5922 26.6167 58.5004C27.5482 57.7349 28.7232 57.3145 29.9374 57.3125C31.1307 57.3125 32.1135 57.6898 32.794 58.4043C33.2592 58.8982 33.7966 59.798 33.6884 61.2739L33.607 62.3886H29.2058L29.1988 62.2354C29.1422 62.4374 29.0794 62.679 29.0104 62.9603C29.0109 62.9671 29.0109 62.974 29.0104 62.9808H33.5546L32.8765 64.6294C31.9972 66.7765 30.1467 68.0593 27.9264 68.0593Z",
    fill: "#909A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4082 67.9881L32.9856 57.3809H41.8183L39.2013 67.9881H30.4082Z",
    fill: "#909A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2128 67.9881L43.1314 66.766H42.4149L41.7019 67.9881H36.6738L43.2384 57.3809H46.6021L47.878 67.9881H43.2128Z",
    fill: "#909A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5625 67.9881L49.4127 64.6372L52.2158 61.5812H50.3293L51.3947 57.3809H59.4678L58.6059 60.7318L58.4047 60.9524L55.7924 63.7878H57.8208L56.7415 67.9881H48.5625Z",
    fill: "#909A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1777 67.9881L57.911 57.3809H66.1389L65.0432 61.5812H64.5128L63.9383 63.7878H64.4675L63.3707 67.9881H55.1777Z",
    fill: "#909A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8751 67.9881L66.7739 67.5L66.6448 67.9881H62.0645L64.8408 57.3809H69.1106C70.3202 57.3809 71.3274 57.8153 71.9462 58.603C72.565 59.3907 72.7418 60.4437 72.4545 61.5241C72.1904 62.4981 71.5891 63.3512 70.754 63.9364L71.8194 67.9881H66.8751Z",
    fill: "#909A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8641 64.8718H45.9824L47.0106 57.373H52.3051L51.0036 60.509H51.8468L48.611 67.9609L46.4244 68.0329L46.8641 64.8718Z",
    fill: "#909A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6018 64.1554C29.2971 64.7396 28.9191 64.9992 28.3747 64.9992C28.0549 64.9992 27.8083 64.8848 27.7013 64.6848C27.585 64.4561 27.5199 64.1806 27.8758 62.6978C28.2317 61.2149 28.4282 60.9303 28.6643 60.6982C28.8936 60.4827 29.1998 60.3644 29.5169 60.3689C30.0484 60.3689 30.295 60.6216 30.3183 61.1886V61.2447H32.5282V61.1909C32.591 60.3346 32.3933 59.6589 31.9466 59.1822C31.5 58.7055 30.7998 58.4551 29.9379 58.4551C28.9889 58.4551 28.1409 58.7603 27.3454 59.3903C26.2811 60.234 26.016 61.351 25.7345 62.5331L25.6693 62.8075C25.3844 63.9942 25.1157 65.1146 25.7857 65.9687C26.2788 66.6043 26.9813 66.9153 27.9269 66.9153C29.6507 66.9153 31.0964 65.9024 31.7943 64.2057L31.8268 64.1257H29.6169L29.6018 64.1554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1566 58.5254L37.382 61.682H35.3163L36.0874 58.5254H33.9043L31.8828 66.845H34.0567L34.8499 63.5958H36.9121L36.1142 66.845H38.288L40.3398 58.5254H38.1566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8944 58.5254L38.7441 66.8461H41.0296L41.7426 65.624H44.2224L44.3038 66.8461H46.5707L45.5704 58.5254H43.8944ZM44.0944 63.8302H42.8057L43.9537 61.8866L44.0944 63.8302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5389 60.1889L57.5482 60.1786L57.9739 58.5254H52.3037L51.8175 60.4381H54.8312L50.4707 65.1918L50.0508 66.845H55.8349L56.3269 64.9311H53.1691L57.5389 60.1889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.786 63.6072L63.2849 61.6934H60.1806L60.5063 60.4381H64.1421L64.6411 58.5254H58.8174L56.6738 66.845H62.4696L62.9686 64.9311H59.3432L59.6863 63.6072H62.786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0277 59.304C70.6276 58.7952 69.9647 58.5254 69.1121 58.5254H65.7391L63.5664 66.8461H65.7403L66.5428 63.7924H67.1418L67.8152 66.8461H70.3194L69.4122 63.398C69.8263 63.2105 70.9754 62.5771 71.3313 61.2372C71.5256 60.5021 71.4151 59.7967 71.0277 59.304ZM68.1025 61.9941H67.0162L67.4209 60.4518H68.541C68.6406 60.4444 68.7406 60.4602 68.8329 60.4977C68.9253 60.5352 69.0073 60.5935 69.0726 60.6679C69.1279 60.7454 69.1644 60.8343 69.1794 60.9279C69.1943 61.0214 69.1872 61.1171 69.1586 61.2075C69.0918 61.4326 68.953 61.6307 68.7628 61.7723C68.5726 61.914 68.3411 61.9917 68.1025 61.9941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0278 58.5176L47.3125 63.7298H48.1976L47.7638 66.8463L47.8324 66.844L50.0865 61.6536H49.2735L50.575 58.5176H48.0278Z",
    fill: "#7FBC27"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1489 188H78.7345C89.3087 188 97.8741 178.459 97.8834 166.702V154.693C97.8834 154.37 97.6217 154.109 97.299 154.109H96.5094C95.5619 154.109 94.7909 153.078 94.7909 151.796V140.305C94.7959 139.03 95.5619 137.992 96.5094 137.992H97.299C97.6217 137.992 97.8834 137.73 97.8834 137.408L97.8834 22.3079C97.8834 10.5415 89.3087 1 78.7345 1L19.1489 1C8.57468 1 0 10.5415 0 22.3079L0 166.692C0 178.459 8.57468 188 19.1489 188Z",
    fill: "#101728"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1336 154.107H94.1211V137.99H96.1336C97.2487 137.99 98.1547 139.048 98.1547 140.351V151.757C98.1547 153.049 97.2487 154.107 96.1336 154.107Z",
    fill: "#101728"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7909 187.939V150.806C17.7909 149.879 17.1847 149.082 16.5624 148.394C15.9818 147.753 15.6289 146.903 15.6289 145.973V124.285C15.6289 123.352 15.9824 122.503 16.5623 121.863C17.1849 121.176 17.7909 120.379 17.7909 119.452V114.27C17.7909 110.815 20.6055 108.008 24.0702 108.008H70.0782C73.543 108.008 76.3575 110.815 76.3575 114.27V119.46C76.3575 120.385 76.9607 121.181 77.5805 121.867C78.1589 122.508 78.5103 123.356 78.5103 124.285V145.973C78.5103 146.901 78.1589 147.749 77.5805 148.39C76.9607 149.077 76.3575 149.873 76.3575 150.798V187.939H17.7909Z",
    fill: "#4D5A61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4404 117.734V126.017C35.4404 128.397 35.1246 130.76 34.5115 133.057C33.8984 135.355 33.5826 146.981 33.5826 149.362V187.938H25.1761L25.1761 149.362C25.1761 146.981 24.8603 135.355 24.2473 133.057C23.6342 130.76 23.3184 128.397 23.3184 126.017V117.734H35.4404Z",
    fill: "url(#paint0_linear_4079_118889)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8545 117.734V126.017C53.8545 128.397 53.5386 130.76 52.9256 133.057C52.3125 135.355 51.9967 146.981 51.9967 149.362V187.938H43.5902L43.5902 149.362C43.5902 146.981 43.2744 135.355 42.6613 133.057C42.0482 130.76 41.7324 128.397 41.7324 126.017V117.734H53.8545Z",
    fill: "url(#paint1_linear_4079_118889)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0087 117.734V126.017C72.0087 128.397 71.6929 130.76 71.0799 133.057C70.4668 135.355 70.151 146.981 70.151 149.362V187.938H61.7445L61.7445 149.362C61.7445 146.981 61.4287 135.355 60.8156 133.057C60.2025 130.76 59.8867 128.397 59.8867 126.017V117.734H72.0087Z",
    fill: "url(#paint2_linear_4079_118889)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2869 117.751H24.875V114.028C24.875 113.116 25.4481 112.379 26.1571 112.379H33.0048C33.7138 112.379 34.2869 113.116 34.2869 114.028V117.751Z",
    fill: "#EDEFF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3336 113.721H26.4512V117.078H27.3336V113.721Z",
    fill: "#909A9F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8239 113.721H28.9414V117.078H29.8239V113.721Z",
    fill: "#909A9F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4039 113.721H31.5215V117.078H32.4039V113.721Z",
    fill: "#909A9F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5916 117.751H61.1797V112.769C61.1797 112.553 61.3837 112.379 61.6362 112.379H70.135C70.3876 112.379 70.5916 112.553 70.5916 112.769V117.751Z",
    fill: "#EDEFF0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8649 113.721H62.9824V116.407H63.8649V113.721Z",
    fill: "#909A9F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3414 113.721H65.459V116.407H66.3414V113.721Z",
    fill: "#909A9F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9274 113.721H68.0449V116.407H68.9274V113.721Z",
    fill: "#909A9F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3091 117.734H43.2988V112.935C43.2988 112.713 43.4846 112.527 43.7075 112.527H51.8911C52.114 112.527 52.2998 112.713 52.2998 112.935V117.734H52.3091Z",
    fill: "#EDEFF0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5782 113.75H45.0234V114.954H50.5782V113.75Z",
    fill: "#909A9F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9602 171.599C82.4522 171.599 80.418 169.57 80.418 167.068V162.325C80.418 159.824 82.4522 157.795 84.9602 157.795C87.4683 157.795 89.5025 159.824 89.5025 162.325V167.068C89.5025 169.57 87.4683 171.599 84.9602 171.599Z",
    fill: "#7FBC27"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.255 150.57C37.1125 150.57 36.1836 151.497 36.1836 152.636V187.942H40.3172V152.636C40.3172 151.497 39.3976 150.57 38.255 150.57Z",
    fill: "#101728"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.88 150.57C55.7375 150.57 54.8086 151.497 54.8086 152.636V187.942H58.9422V152.636C58.9515 151.497 58.0226 150.57 56.88 150.57Z",
    fill: "#101728"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2651 164.834V167.104C85.2651 167.354 85.0607 167.558 84.8099 167.558C84.5591 167.558 84.3548 167.354 84.3548 167.104V164.834C84.3548 164.584 84.5591 164.38 84.8099 164.38C85.0607 164.38 85.2651 164.584 85.2651 164.834ZM82.9986 166.9C83.1472 167.021 83.3609 166.993 83.4816 166.845C83.6024 166.697 83.5745 166.483 83.4259 166.363C82.8871 165.937 82.5713 165.298 82.5713 164.612C82.5713 163.38 83.5745 162.379 84.8099 162.379C86.0454 162.379 87.0486 163.38 87.0486 164.612C87.0486 165.298 86.742 165.937 86.194 166.363C86.0454 166.483 86.0175 166.697 86.1382 166.845C86.259 166.993 86.4727 167.021 86.6213 166.9C87.3272 166.344 87.7359 165.511 87.7359 164.612C87.7359 163.009 86.4262 161.703 84.8192 161.703C83.2122 161.703 81.9025 163.009 81.9025 164.612C81.8932 165.511 82.2926 166.344 82.9986 166.9Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4079_118889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8422 52.9771C22.2218 52.9771 20.9485 52.3863 20.0609 51.2277C18.8234 49.6174 19.2736 47.7289 19.6651 46.0626L19.7468 45.7199C20.1139 44.1426 20.5312 42.3573 22.2276 40.9879C23.376 40.0278 24.8246 39.5006 26.3215 39.498C27.7927 39.498 29.0044 39.9712 29.8432 40.8675C30.4168 41.4869 31.0793 42.6154 30.9459 44.4667L30.8455 45.8648H25.4195L25.4109 45.6726C25.3411 45.9259 25.2637 46.229 25.1786 46.5817C25.1793 46.5903 25.1793 46.5989 25.1786 46.6075H30.781L29.945 48.6753C28.861 51.3682 26.5796 52.9771 23.8422 52.9771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9023 52.8901L30.08 39.5859H40.9693L37.743 52.8901H26.9023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6827 52.8901L42.5823 51.3572H41.699L40.82 52.8901H34.6211L42.7143 39.5859H46.8612L48.4343 52.8901H42.6827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2793 52.8901L50.3275 48.6872L53.7833 44.8542H51.4575L52.7709 39.5859H62.724L61.6614 43.7888L61.4133 44.0656L58.1927 47.6218H60.6935L59.3628 52.8901H49.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4375 52.8901L60.8073 39.5859H70.951L69.6002 44.8542H68.9463L68.238 47.6218H68.8904L67.5382 52.8901H57.4375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8585 52.8901L71.7338 52.2778L71.5746 52.8901H65.9277L69.3506 39.5859H74.6146C76.1059 39.5859 77.3477 40.1308 78.1105 41.1188C78.8734 42.1068 79.0913 43.4275 78.7372 44.7826C78.4116 46.0042 77.6702 47.0742 76.6407 47.8082L77.9542 52.8901H71.8585Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1846 48.9814H46.0977L47.3653 39.5762H53.8926L52.288 43.5095H53.3276L49.3384 52.8559L46.6426 52.9463L47.1846 48.9814Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9043 48.0852C25.5286 48.8179 25.0626 49.1434 24.3915 49.1434C23.9971 49.1434 23.6931 49 23.5612 48.7491C23.4178 48.4623 23.3375 48.1167 23.7763 46.2569C24.2151 44.3971 24.4574 44.04 24.7485 43.7489C25.0311 43.4787 25.4086 43.3304 25.7996 43.336C26.4549 43.336 26.7589 43.6529 26.7876 44.3641V44.4344H29.5121V44.367C29.5895 43.293 29.3457 42.4455 28.7951 41.8475C28.2445 41.2496 27.3812 40.9355 26.3187 40.9355C25.1486 40.9355 24.1032 41.3184 23.1224 42.1085C21.8104 43.1668 21.4834 44.5677 21.1364 46.0504L21.0561 46.3946C20.7048 47.883 20.3736 49.2883 21.1995 50.3594C21.8075 51.1567 22.6736 51.5467 23.8394 51.5467C25.9645 51.5467 27.7469 50.2763 28.6073 48.1483L28.6474 48.0479H25.9229L25.9043 48.0852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4495 41.0215L35.4945 44.9806H32.9478L33.8985 41.0215H31.207L28.7148 51.4563H31.3949L32.3728 47.381H34.9152L33.9315 51.4563H36.6116L39.141 41.0215H36.4495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5272 41.0195L37.1777 51.4558H39.9954L40.8744 49.9229H43.9316L44.032 51.4558H46.8267L45.5935 41.0195H43.5272ZM43.7739 47.673H42.1851L43.6004 45.2353L43.7739 47.673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.347 43.1079L60.3585 43.095L60.8833 41.0215H53.8928L53.2934 43.4205H57.0088L51.6329 49.3828L51.1152 51.4563H58.2462L58.8528 49.0559H54.9596L60.347 43.1079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8147 47.3954L67.4298 44.9949H63.6026L64.0041 43.4205H68.4866L69.1018 41.0215H61.9221L59.2793 51.4563H66.4246L67.0398 49.0559H62.5702L62.9932 47.3954H66.8147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9781 41.996C76.4848 41.3579 75.6674 41.0195 74.6164 41.0195H70.4579L67.7793 51.4558H70.4593L71.4488 47.6257H72.1872L73.0175 51.4558H76.1048L74.9863 47.131C75.4968 46.8958 76.9135 46.1014 77.3523 44.4208C77.5918 43.4988 77.4556 42.6141 76.9781 41.996ZM73.3717 45.3701H72.0324L72.5314 43.4357H73.9123C74.0351 43.4265 74.1584 43.4462 74.2722 43.4933C74.386 43.5403 74.4872 43.6135 74.5676 43.7067C74.6358 43.804 74.6809 43.9155 74.6993 44.0328C74.7176 44.1502 74.7089 44.2701 74.6737 44.3836C74.5913 44.6659 74.4202 44.9143 74.1857 45.092C73.9512 45.2696 73.6658 45.3671 73.3717 45.3701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6202 41.0098L47.7383 47.5471H48.8295L48.2946 51.456L48.3793 51.4532L51.1582 44.9431H50.1559L51.7605 41.0098H48.6202Z",
    fill: "#80BC00"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9648 1.15547L16.312 1.15483C-35.1828 21.1464 55.8986 98.0407 97.698 84.2518L98.0306 26.1441C99.0319 3.84827 83.7787 -1.837 66.9648 1.15547Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4079_118889",
    x1: 29.3754,
    y1: 187.937,
    x2: 29.3754,
    y2: 117.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0838,
    stopColor: "#D0D7C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3328,
    stopColor: "#B4CD7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5577,
    stopColor: "#9DC647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7509,
    stopColor: "#8DC021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9047,
    stopColor: "#84BD09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80BC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4079_118889",
    x1: 47.7976,
    y1: 187.937,
    x2: 47.7976,
    y2: 117.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0838,
    stopColor: "#D0D7C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3328,
    stopColor: "#B4CD7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5577,
    stopColor: "#9DC647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7509,
    stopColor: "#8DC021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9047,
    stopColor: "#84BD09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80BC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4079_118889",
    x1: 65.9515,
    y1: 187.937,
    x2: 65.9515,
    y2: 117.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0838,
    stopColor: "#D0D7C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3328,
    stopColor: "#B4CD7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5577,
    stopColor: "#9DC647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7509,
    stopColor: "#8DC021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9047,
    stopColor: "#84BD09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80BC00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4079_118889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.4039,
    height: 10.7445,
    fill: "white",
    transform: "translate(24.2051 57.3125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4079_118889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.675,
    height: 13.4762,
    fill: "white",
    transform: "translate(19.252 39.498)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPb);
export default __webpack_public_path__ + "static/media/pb.98566b4114e0ad6f046d6ae385120cb0.svg";
export { ForwardRef as ReactComponent };